module.exports = __webpack_public_path__ + "img/bg.be4cf193.png";